import Vuex from "vuex";
import Vue from 'vue';
import axi from './axios.js'
import user from './user.js'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        axi: axi,
        user: user
    }
})